<template>
  <b-row class="features justify-content-center" tag="ul">
    <b-col v-for="n in 3" :key="n" cols="12" md="6" lg="4" tag="li">
      <div class="feature mb-4">
        <img class="mb-2" :src="require(`@/assets/${$toKebabCase($route.name)}/feature_${n}.png`)" :alt="$t(`img.${$route.name}.features.${n}`)" width="42%">
        <h4 v-html="$t(`products.${$route.name}.features.${n}.title`)" />
        <p v-html="$t(`products.${$route.name}.features.${n}.text`)" />
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Features'
}
</script>

<style lang="sass" scoped>
.features
  margin-top: 50px
  margin-bottom: 120px
  padding: 0
  text-align: center
  list-style: none

.feature
  margin: auto
  max-width: 500px

  h4
    font-size: 20px
    +media-breakpoint-down(xs)
      margin-bottom: 0px

  p
    +media-breakpoint-up(md)
      padding: 0 25px
</style>



// WEBPACK FOOTER //
// src/components/ui/products/Features.vue